import * as z from 'zod';

export enum NativeBooleanEnum {
  False,
  True,
}

export const nativeBooleanEnum = z.enum(NativeBooleanEnum);

export const defaultBooleanValue = () => false;

export const booleanQuerySchema = () => z.boolean();
export const nullableBooleanQuerySchema = () => z.boolean().nullable();
export const booleanMutationSchema = () => z.boolean();

export const booleanFormSchema = () => z.boolean();

export const booleanQueryToFormConverter = (value: boolean | null) => {
  return !!value;
};

export const booleanFormToUpdateConverter = (value: boolean) => {
  return !!value;
};

export const numericBooleanQuerySchema = () => nativeBooleanEnum;
export const nullableNumericBooleanQuerySchema = () => nativeBooleanEnum.nullable();
export const booleanNumericMutationSchema = () => nativeBooleanEnum;

export const numericBooleanQueryToFormConverter = (value: NativeBooleanEnum | null) => {
  // cover null case
  return value === NativeBooleanEnum.True; // ? NativeBooleanEnum.True : NativeBooleanEnum.False;
};

export const numericBooleanFormToUpdateConverter = (value: boolean) => {
  return value ? NativeBooleanEnum.True : NativeBooleanEnum.False;
};
